'use client';

import { useEffect } from 'react';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';

export default function VendorProfileTracker({ vendor }) {
  useEffect(() => {
    trackEvent(EVENTS.VENDOR_PROFILE_VIEWED, {
      vendor_username: vendor.username,
      vendor_category: vendor.services?.[0]?.category_sub_category?.category?.name,
      service_count: vendor.services?.length,
      has_location: !!vendor.services?.[0]?.latitude,
      is_marketplace_vendor: !!vendor.is_created_by_marketplace
    });
    // Una vista por página montada: si las props cambian (un objeto nuevo en un refresh del RSC), no
    // es otra vista. Cambiar de página remonta el componente.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
